/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_OpenaiInputs */

const en_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

const fr_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

const de_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

const it_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

const ru_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

const es_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

const zh_cn2_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

const ja_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープンアイ`)
};

const hi_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपनएआई`)
};

const pt_pt2_spellcheck_engine_openai = /** @type {(inputs: Spellcheck_Engine_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAi`)
};

/**
* | output |
* | --- |
* | "OpenAi" |
*
* @param {Spellcheck_Engine_OpenaiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_openai = /** @type {((inputs?: Spellcheck_Engine_OpenaiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_OpenaiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_engine_openai(inputs)
	if (locale === "de") return de_spellcheck_engine_openai(inputs)
	if (locale === "it") return it_spellcheck_engine_openai(inputs)
	if (locale === "ru") return ru_spellcheck_engine_openai(inputs)
	if (locale === "es") return es_spellcheck_engine_openai(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_engine_openai(inputs)
	if (locale === "ja") return ja_spellcheck_engine_openai(inputs)
	if (locale === "hi") return hi_spellcheck_engine_openai(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_engine_openai(inputs)
	return en_spellcheck_engine_openai(inputs)
});